import * as React from "react";

const Champion_Marlene = () => {
  return (
    <ol className="references">
      <li>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit&nbsp;
        <a target="_blank" className="" href="https://google.com">https://google.com</a>
      </li>
    </ol>
  )
}

export default Champion_Marlene;